import { render, staticRenderFns } from "./UnpaidList.vue?vue&type=template&id=0ca5001f&scoped=true&"
import script from "./UnpaidList.vue?vue&type=script&lang=js&"
export * from "./UnpaidList.vue?vue&type=script&lang=js&"
import style0 from "./UnpaidList.vue?vue&type=style&index=0&id=0ca5001f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca5001f",
  null
  
)

export default component.exports